import styled from "styled-components";

export const ChangeLanguageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 120px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;

	.change-lang-header {
		color: var(--main-explosive);
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}
`;

export const LanguageWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 20px;
	align-items: center;
	align-self: stretch;
	min-height: 64px;

	img {
		cursor: pointer;
		width: 20px;
		&.active {
			transform: scale(1.5);
		}
	}
`;

export const ActiveLanguage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--main-secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	letter-spacing: 0.3px;
	min-height: 40px;
`;
